var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10291_2899)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10291_2899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3116 12.4952H5.68935C5.39482 12.4952 5.15601 12.734 5.15601 13.0285C5.15601 13.3231 5.39479 13.5619 5.68935 13.5619H10.3116C10.6061 13.5619 10.8449 13.3231 10.8449 13.0285C10.8449 12.734 10.6061 12.4952 10.3116 12.4952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3116 10.813H5.68935C5.39482 10.813 5.15601 11.0518 5.15601 11.3464C5.15601 11.641 5.39479 11.8797 5.68935 11.8797H10.3116C10.6061 11.8797 10.8449 11.641 10.8449 11.3464C10.8449 11.0518 10.6061 10.813 10.3116 10.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7556 4.18459H13.0586V1.09787C13.0586 0.803342 12.8198 0.564529 12.5253 0.564529H3.47475C3.18022 0.564529 2.94141 0.803311 2.94141 1.09787V4.18459H1.24444C0.55825 4.18459 0 4.74287 0 5.42906V10.7947C0 11.4809 0.55825 12.0392 1.24444 12.0392H2.9415V14.9021C2.9415 15.1967 3.18028 15.4355 3.47484 15.4355H12.5252C12.8197 15.4355 13.0585 15.1967 13.0585 14.9021V12.0392H14.7556C15.4418 12.0392 16 11.4809 16 10.7947V5.42906C16 4.7429 15.4418 4.18459 14.7556 4.18459ZM4.00806 1.63122H11.9919V4.18459H4.00806V1.63122ZM11.9918 14.3688H4.00819C4.00819 14.2646 4.00819 10.1343 4.00819 10.0054H11.9918C11.9918 10.1376 11.9918 14.2686 11.9918 14.3688ZM12.5253 7.31631H11.1677C10.8731 7.31631 10.6343 7.07753 10.6343 6.78297C10.6343 6.4884 10.8731 6.24962 11.1677 6.24962H12.5253C12.8198 6.24962 13.0586 6.4884 13.0586 6.78297C13.0586 7.07753 12.8198 7.31631 12.5253 7.31631Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10291_2899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10291_2899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.da8c92133746763fa8bf2b7376792e32.svg";
export { ForwardRef as ReactComponent };